import { useQuery, useMutation } from 'react-query'
import { useAxios } from 'packages/core'
import { checkIfAnonymousUserGuid } from 'utils'

export const CURRENT_PERSON_KEY = 'CURRENT_PERSON'
export const PERSON_KEY = 'PERSON'

export const useCurrentPerson = () => {
    const callApi = useAxios()
    return useQuery(
        CURRENT_PERSON_KEY,
        () =>
            callApi({
                method: 'GET',
                url: '/api/people',
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}

export const usePerson = (personId) => {
    const callApi = useAxios()
    return useQuery(
        [PERSON_KEY, personId],
        () =>
            callApi({
                method: 'GET',
                url: `/api/people?personId=${personId}`,
            }).then((data) => data.data),
        {
            enabled: Boolean(checkIfAnonymousUserGuid(personId)),
            staleTime: Infinity,
        },
    )
}

export const useUpdatePersonLocale = () => {
    const callApi = useAxios()
    return useMutation(
        (locale) =>
            callApi({
                method: 'PATCH',
                url: '/api/user/language',
                data: locale,
            }),
        {
            onSuccess: () => {
                window.location.reload()
            },
        },
    )
}
